import axios from 'axios';

const dev = process.env.REACT_APP_API_ROOT;

const instance = axios.create({
    baseURL: dev,
});

export default instance;
